"use client";

import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { toast } from 'sonner';
import {
    Dialog,
    DialogContent,
} from "@/components/ui/dialog";
import JoinArthaaverse from '@/components/join-arthaverse';
import ConnectForm from './connectForm';

interface ConnectButtonProps {
    professionalId?: string;
    professionalName?: string;
    className?: string;
    user?: { user: string; token: string; type: string; email?: string } | null;
    professionalSlug?: string;
}

export function ConnectButton({
    professionalId,
    professionalName,
    className = "",
    user,
    professionalSlug,
}: ConnectButtonProps) {
    const [isConnected, setIsConnected] = useState(false);
    const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
    const [isNoteModalOpen, setIsNoteModalOpen] = useState(false);

    const handleConnectClick = async () => {
        if (!user?.token || !user?.user) {
            setIsAuthModalOpen(true);
            return;
        }

        if (isConnected) {
            toast.info(`You are already connected with ${professionalName || 'this professional'}.`);
            return;
        }

        setIsNoteModalOpen(true);
    };

    return (
        <>
            <button
                onClick={handleConnectClick}
                className={`bg-blue-600 hover:bg-blue-700 disabled:opacity-75 text-white text-xs font-bold px-6 py-2.5 rounded-lg shadow-sm hover:shadow transition-all tracking-wider uppercase inline-flex items-center justify-center gap-2 cursor-pointer ${className}`}
            >
                {isConnected ? (
                    <>
                        <Check className="w-3.5 h-3.5" />
                        <span>CONNECTED</span>
                    </>
                ) : (
                    <span>CONNECT NOW</span>
                )}
            </button>

            {/* Note / Reason Modal for Authenticated Users */}
            <Dialog
                open={isNoteModalOpen}
                onOpenChange={setIsNoteModalOpen}
            >
                <DialogContent className="sm:max-w-lg p-6 rounded-2xl border border-slate-100 shadow-xl max-h-[90vh] overflow-y-auto">
                    <ConnectForm
                        professionalId={professionalId}
                        professionalName={professionalName}
                        user={user}
                        onSuccess={() => {
                            setIsConnected(true);
                        }}
                        onCancel={() => setIsNoteModalOpen(false)}
                    />
                </DialogContent>
            </Dialog>

            {/* Join Arthaverse Auth Modal for Unauthenticated Users */}
            <JoinArthaaverse open={isAuthModalOpen} onOpenChange={setIsAuthModalOpen} profId={professionalSlug} />
        </>
    );
}

export default ConnectButton;

